import { FunctionComponent, Suspense } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { theme } from '@flos/react-components';
import './App.css';
import './progress-bar.css';
import RouterApp, { fallBack } from './../router/RouterApp';
import CloseButton from '../components/shared/close-button/CloseButton';
import { IAppProps } from '../common/interface/IAppProvider';
import { useGlobalState } from '../common/context/AppContext';
import { ProgressBar } from '../components/shared/progress-bar/ProgressBar';
import { getContentBlock, getResourceBundle } from '../common/actions/GetResourceBundle';
import Banner from '../components/shared/banner/Banner';
import { useLocation } from 'react-router-dom';
// To to add more resource bundles, just add the identifier

import { ReactComponent as TdLogo } from './../assets/images/logo_tif.svg';
const resourceBundlesList = ['dk.onsa-common', 'onsa-erhvervsforsikring/'];

// To add more content blocks, just add the identifier
export const contentBlockList = [
    'claimsrmo',
    'profoverlay',
    'profoverlay-category-a',
    'profoverlay-category-b',
    'profoverlay-category-c',
    'cyberoverlay',
    'injuryquoteoverlay',
    'injurycproverlay',
    'onsa-b2b-work',
    'onsa-b2b-responsebility',
    'onsa-b2b-legal',
    'onsa-b2b-various',
    'onsa-b2b-netbank',
    'receipt-quote',
    'receipt-buy',
    'entitled-to-buy',
    'entitled-to-buy-list',
    'entitled-to-buy-quote',
    'indtast-cvr-nummer-v2',
    'unknown-cvr',
    'contact-info',
    'payment',
    'compliance',
    'quote',
    'quote-branch',
    'quote-employees',
    'bestil-tilbud-customer-request',
    'fees-and-charges',
    'coverage-options',
    'quote-insurance-package',
    'quote-insurance-additional-discount',
    'carpenter-losoreforsikring-compliance',
    'carpenter-ansvar-compliance',
    'painter-ansvar-compliance',
    'painter-losoreforsikring-compliance',
    'masons-ansvar-compliance',
    'masons-losoreforsikring-compliance',
    'cleaner-ansvar-compliance',
    'cleaner-losoreforsikring-compliance',
    'coverage-transport',
    'coverage-prof-liability',
    'coverage-product-liability',
    'coverage-occupational-injury',
    'coverage-netbank',
    'coverage-legal-aid',
    'coverage-asset',
    'coverage-all-asset',
    'coverage-it-udstyr',
    'coverage-liability',
    'vanoverlay',
    'common/rmo-generel-fejlmeddelelse',
    'common/rmo-overlay-receipt',
    'common/help-receipt-b2b',
    'common/404',
];

export const App: FunctionComponent<IAppProps> = (props): JSX.Element => {
    // themeObject passed to MuiThemeProvider
    const { refreshFromCache, actualStep } = useGlobalState();
    const location = useLocation();
    const baseUrl = window.location.origin;

    // Click on the close button
    const handleCloseButtonEvent = (): void => {
        window.location.assign('https://www.topdanmark.dk/erhverv/erhvervsforsikringer/');
    };

    // start loading all the content blocks
    for (let value of contentBlockList) {
        if (!(value in props.config.contentBlocks)) {
            props.config.contentBlocks[value] = getContentBlock(value);
        }
    }

    // start loading all the resource bundles
    for (let value of resourceBundlesList) {
        if (!(value in props.config.resourceBundles)) {
            props.config.resourceBundles[value] = getResourceBundle(value);
        }
    }
    return (
        <div className="onsa-main-wrapper">
            <div className="onsa-header">
                <Container fixed>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <a
                                href={`${baseUrl}/erhverv/erhvervsforsikringer/`}
                                title="Tilbage til forsikringsoversigten"
                            >
                                <TdLogo width={164} height={41} />
                            </a>
                        </Grid>
                        <Grid item xs={6}>
                            <div className="text-align-right">
                                <CloseButton onClickEventHandler={handleCloseButtonEvent} />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            {actualStep > 8 && actualStep < 15 && (
                <div className="progress-bar-wrapper">
                    <div className="progress-bar-inner-wrapper">
                        <Suspense fallback={fallBack}>
                            <ProgressBar {...props} />
                        </Suspense>
                    </div>
                </div>
            )}
            {location.pathname.includes('/pakke') && (
                <Suspense fallback={fallBack}>
                    <Banner {...props} />
                </Suspense>
            )}
            <div className="row onsa-content-area">
                <Container fixed>
                    <MuiThemeProvider theme={theme}>
                        <div className="onsa-main-inner-wrapper">{refreshFromCache && <RouterApp {...props} />}</div>
                    </MuiThemeProvider>
                </Container>
            </div>
        </div>
    );
};

export default App;
